export enum PensionProductType {
  PENSJONSKAPITALBEVIS = "PKB",
  EGEN_PENSJONSKONTO = "EPK",
  KAPITALFORSIKRING = "KPF",
  IPS = "IPS",
  IPS_OLD = "IPO",
  IPA = "IPA",
  LIVRENTE = "LVR",
  FRIPOLISE = "FRP",
}

export type PensionProductTypeData = {
  path: string;
  displayName: string;
  apiId: number;
};

export const PensionProductTypeData: Record<
  PensionProductType,
  PensionProductTypeData
> = {
  [PensionProductType.PENSJONSKAPITALBEVIS]: {
    path: "/pensjonskapitalbevis",
    displayName: "Pensjonskapitalbevis",
    apiId: 4,
  },
  [PensionProductType.EGEN_PENSJONSKONTO]: {
    path: "/pensjonskonto",
    displayName: "Egen pensjonskonto",
    apiId: 8,
  },
  [PensionProductType.KAPITALFORSIKRING]: {
    path: "/kapitalforsikring",
    displayName: "Kapitalforsikring",
    apiId: 2,
  },
  [PensionProductType.IPS]: {
    path: "/ips",
    displayName: "IPS",
    apiId: 5,
  },
  [PensionProductType.IPS_OLD]: {
    path: "/ips-gammel",
    displayName: "IPS (gammel ordning)",
    apiId: 7,
  },
  [PensionProductType.IPA]: {
    path: "/ipa",
    displayName: "IPA",
    apiId: 1,
  },
  [PensionProductType.LIVRENTE]: {
    path: "/livrente",
    displayName: "Livrente",
    apiId: 3,
  },
  [PensionProductType.FRIPOLISE]: {
    path: "/fripolise",
    displayName: "Fripolise med investeringsvalg",
    apiId: 6,
  },
};

const pensionProductTypeByPath = Object.entries(PensionProductTypeData).reduce(
  (
    accumulator: Record<string, PensionProductType>,
    [productType, { path: productPath }],
  ) => {
    accumulator[productPath] = productType as PensionProductType;
    return accumulator;
  },
  {},
);

export function getPensionProductType(path: string) {
  return pensionProductTypeByPath[`/${path}`];
}
